module.exports = "<div>\n    <side-details></side-details>\n</div>"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/credibility.component.html
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/credibility.component.html
// module chunks = main